<template>
  <div>
    <div class="ubold-title" style="margin-bottom: 40px">域名订单详情</div>
    <div class="bj-panl">
      <div class="bj-rows content-between" style="border-bottom: 1px solid #fff;padding-bottom: 20px;">
        <div class="status">{{ detail.tradeState | status }}</div>
        <div class="bj-rows" style="pad">
          <div class="i-price">实付金额：<div>{{ detail.total || 0 }}</div>元</div>
          <div v-if="detail.tradeState === 0">
            <Button class="pay-btn" @click="onPay" :loading="payLoading">付款</Button>
            <Button class="cancel-btn" @click="onCancel" :loading="cancelLoading">取消</Button>
          </div>
        </div>
      </div>
      <div class="bt-section">
        <div class="bj-rows content-between">
          <div class="bj-rows">
            <div class="name">订单号：</div>
            <div>{{ detail.outTradeNo }}</div>
          </div>
          <div class="bj-rows">
            <div class="name">创建时间：</div>
            <div>{{ detail.createdTime }}</div>
          </div>
        </div>
        <div class="bj-rows content-between" style="margin-top: 15px;" v-if="detail.tradeState === 1">
          <div class="bj-rows">
            <div class="name">付款时间</div>
            <div>{{ detail.payTime }}</div>
          </div>
        </div>
      </div>
      
    </div>
    <div class="bj-table-data">
      <Table
        class="bj-2F3033-table"
        stripe
        :columns="columns"
        :data="data"
        :loading="tableLoading"
      >
      </Table>
      <div class="z-total">
        实付：
        <div style="color: #ff5c35; font-weight: Bold">
          {{ detail.total || 0 }}元
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { orderDetail, orderCancel } from "api/domain.js";

export default {
  name: "orderDetail",
  filters: {
    status(val) {
      let title = "";
      switch (val) {
        case 0:
          title = "待支付";
          break;
        case 1:
          title = "交易成功";
          break;
        case 2:
          title = "已取消";
          break;
        case 3:
          title = "已过期";
          break;
      }
      return title;
    },
  },
  data() {
    return {
      detail: {
        tradeState: 1,
      },
      domainName: "",
      page: 1,
      limit: 20,
      total: 0,
      columns: [
        {
          title: "序号",
          align: "center",
          type: "index",
        },
        {
          title: "产品名称",
          align: "center",
          key: "goodsName",
        },
        {
          title: "单价",
          align: "center",
          key: "unit",
          render: (h, { row }) => {
            return h("div", row.price + "元/年");
          },
        },
        {
          title: "数量",
          align: "center",
          key: "counts",
        },
        {
          title: "小计",
          align: "center",
          key: "amount",
        },
      ],
      data: [],
      tableLoading: false,
      payLoading: false,
      cancelLoading: false,
    };
  },
  created() {
    this.req_getList();
  },
  methods: {
    // 请求
    async req_getList() {
      try {
        const params = {
          orderNo: this.$route.query.id,
        };
        this.tableLoading = true;
        const { code, data } = await orderDetail(params);
        this.tableLoading = false;
        if (code === 200) {
          this.detail.amount = data.amount;
          this.detail.createdTime = data.createdTime;
          this.detail.outTradeNo = data.id;
          this.detail.payTime = data.pay;
          this.detail.total = data.total;
          this.detail.tradeState = data.state;
          this.data = data.orderDetailList;
          this.total = data.total;
        }
      } catch (error) {
        this.tableLoading = false;
        console.log(error);
      }
    },
    // 取消订单
    async onCancel() {
      try {
        this.cancelLoading = true;
        let params = {
          orderNo: this.detail.outTradeNo,
        };
        const { code, result } = await orderCancel(params);
        this.cancelLoading = false;
        if (code === 200 && result) {
          this.$Message.success("操作成功!");
        } else {
          this.$Message.warning("操作失败!");
        }
      } catch (error) {
        this.cancelLoading = false;
        console.log(error);
      }
    },
    // 付款
    onPay() {
      this.$router.push({
        path: "/cart",
        query: { id: this.detail.outTradeNo },
      });
    },
  },
};
</script>
<style lang="less" scoped>
  .bj-panl{
    background-color: #F75733;
    border-radius: 6px;
    padding: 40px;
    margin-bottom: 30px;
    .status{
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
    .i-price{
      display: flex;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
    .pay-btn{
      margin-left: 60px;
      background-color: #fff;
      border-color: #F75733;
      color: #F75733;
      text-align: center;
      width: 100px;
      height: 40px;
      line-height: 40px;
    }
    .cancel-btn{
      margin-left: 20px;
      text-align: center;
      width: 100px;
      height: 40px;
      line-height: 40px;
      color: #fff;
      background-color: #F75733;
      &:hover{
        border-color: #fff;
      }
    }
  }
  .bt-section{
    padding: 15px 0 0 0; 
    color: #fff;
  }
  .z-total{
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
    color: #fff;
  }

</style>
